import { render, staticRenderFns } from "./Resend.vue?vue&type=template&id=76731a4c&"
import script from "./Resend.vue?vue&type=script&lang=ts&"
export * from "./Resend.vue?vue&type=script&lang=ts&"
import style0 from "./Resend.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports